export default "<router-outlet></router-outlet>\r\n<app-ccx-loader [showLoader]=\"showLoader\"></app-ccx-loader>";